import React, { Component } from 'react';
import { Card, Input, Button } from 'webdep-react-controls';
import FormGroup from 'Components/FormGroup';
import renderComponent from 'Helpers/renderComponent';
import "@babel/polyfill";
import 'Styles/login';

class LoginForm extends Component {
  render() {
    const tokenName = document.getElementsByName('csrf-param')[0].getAttribute('content');
    const tokenValue = document.getElementsByName('csrf-token')[0].getAttribute('content');
    const { name, url } = this.props;

    return (
      <div>
        <Card style={{ width: '360px', margin: '60px auto 0 auto' }}>
          <Card.Header>SWAAPPS</Card.Header>
          <Card.Body>
            <form action={url} acceptCharset="UTF-8" method="post" autocomplete="off">
              <img src="/img/login-form-logo.png" style={{ display: 'block', height: '100px', margin: '0 auto' }} />
              <input type="hidden" name={tokenName} value={tokenValue} />
              <FormGroup label="Email">
                <Input type="email" name={`${name}[email]`} />
              </FormGroup>
              <FormGroup label="Password">
                <Input type="password" name={`${name}[password]`} />
              </FormGroup>
              <FormGroup>
                <label>
                  <input type="checkbox" name={`${name}[remember_me]`} />
                  &nbsp;Remember me
                </label>
              </FormGroup>
              <div className="d-flex">
                <Button className="mr-auto" type="link" state='secondary' href="/">Sign in with SAML</Button>
                <Button type="submit">Sign In</Button>
              </div>
            </form>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  renderComponent(LoginForm);
});
